import { Fragment, useEffect, useContext, useState } from "react";
import { Row, Col, Card } from "react-bootstrap";
import { abpnClient } from "../Services/AbpnClient";
import { AuthContext } from "./Auth/AuthProvider";
import { AssessmentResult } from "./Dashboard/Models/Assessment";
import AbpnSpinner from "./Shared/Components/AbpnSpinner";
import { ProfileContext } from "../Components/Auth/ProfileProvider";
import AssessmentCard from "./Dashboard/Assessments/AssessmentCard";
import { Banner } from "./Shared/Components/Banner";

export default function OtherBoardHome() {

    const [assessments, setAssessments] = useState<Array<AssessmentResult>>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const authContext = useContext(AuthContext);
    const { user } = useContext(ProfileContext);

    useEffect(()=>{
        const loadAssessments = async () => {
            setIsLoading(true);
            const results = await abpnClient.get<Array<AssessmentResult>>(`/api/OtherBoard/GetOtherBoardPhysicianLearningTracks`,authContext);
            setAssessments(results);
            setIsLoading(false);
        }

        if (user) {
            loadAssessments();
        }
    },[user]);

    if (!user) return <AbpnSpinner />
    return (
        <Fragment>
            <Banner></Banner>
            <Col xs={12} md={6}>
                {isLoading ? <AbpnSpinner /> :
                    <Card className="mb-4" border="pp-secondary-grey">
                        <Card.Body>
                            <Card.Title className="mb-0 font-weight-bolder">
                                <span className="text-pp-primary">Assessments</span>
                            </Card.Title>
                            <Row className="mt-3">
                                <Col xs={12} md={12} lg={12} xl={12}>
                                    <Fragment>
                                            <Fragment>
                                                {assessments.map((assessment: AssessmentResult, index: number) => {
                                                        return <AssessmentCard key={index} assessment={assessment} />
                                                })}
                                            </Fragment>
                                    </Fragment>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                }
            </Col>
        </Fragment >
    );
}